import React from "react";
import styles from "./Menu.module.css";

// Import components
import Navbar from "../components/Navbar";
import HeadingOne from "../components/HeadingOne";
import Footer from "../components/Footer";
import QuickAccessBar from "../components/QuickAccessBar";

// Import media
import PageOne from "../assets/menu_p1_12_2024.jpg";
import PageTwo from "../assets/menu_p2_12_2024.jpg";
import PageThree from "../assets/menu_pages/happy_hour_v2.jpg";

function Menu() {
  return (
    <div className={styles.menuPage}>
      {/* ########## NAVIGATION BAR ########## */}
      <Navbar
        additionalClassNames={styles.navBar}
        background={"transparent"}
        page={"menu"}
      ></Navbar>

      {/* ########## QUICK ACCESS BAR ########## */}
      <QuickAccessBar />

      {/* Ghost space (Fixes weird blank space on top of the page) */}
      <div className={styles.ghostSpace}></div>

      {/* ########## MENU PAGES ########## */}
      <HeadingOne additionalClassNames={styles.menuPageTitle}>
        OUR MENU
      </HeadingOne>
      <div className={styles.menuPageContainer}>
        <img
          className={styles.singleMenuPage}
          src={PageOne}
          alt="Menu page one"
        />
        <img
          className={styles.singleMenuPage}
          src={PageTwo}
          alt="Menu page two"
        />
        <img
          className={styles.singleMenuPageSmall}
          src={PageThree}
          alt="Menu page three"
        />
      </div>

      {/* ########## MENU PAGES ########## */}
      <Footer></Footer>
    </div>
  );
}

export default Menu;
